import { action, observable, computed, makeObservable } from "mobx";
import { HomePageModel } from "./HomePageModel";

export default class HomePageCMSModel {
  constructor() {
    makeObservable(this);
  }
  @observable response: HomePageModel;

  @action reset = () => {
    this.response = null;
  };
}
